import { EThemesOG } from '@/constants/themeConfig';
import * as sterlingparker from './Promotions.styles.sterlingparker';
import * as betroyale from './Promotions.styles.betroyale';
import * as puntcity from './Promotions.styles.puntcity';
import * as betprofessor from './Promotions.styles.betprofessor';
import * as junglebet from './Promotions.styles.junglebet';
import * as juicybet from './Promotions.styles.juicybet';
import * as puntgenie from './Promotions.styles.puntgenie';
import * as volcanobet from './Promotions.styles.volcanobet';
import * as goldenrush from './Promotions.styles.goldenrush';
import * as wellbet from './Promotions.styles.wellbet';
import * as questbet from './Promotions.styles.questbet';
import * as vikingbet from './Promotions.styles.vikingbet';
import * as betgalaxy from './Promotions.styles.betgalaxy';
import * as fiestabet from './Promotions.styles.fiestabet';
import * as sugarcastle from './Promotions.styles.sugarcastle';
import * as oldgill from './Promotions.styles.oldgill';
import * as buffalobet from './Promotions.styles.buffalobet';
import * as titanbet from './Promotions.styles.titanbet';
import * as slambet from './Promotions.styles.slambet';
import * as gigabet from './Promotions.styles.gigabet';
import * as betstride from './Promotions.styles.betstride';
import * as templebet from './Promotions.styles.templebet';
import * as goldenbet888 from './Promotions.styles.goldenbet888';
import * as hyperbet from './Promotions.styles.hyperbet';
import * as bet777 from './Promotions.styles.bet777';
import * as chromabet from './Promotions.styles.chromabet';
import * as bet575 from './Promotions.styles.bet575';
import * as epicodds from './Promotions.styles.epicodds';
import * as magnumbet from './Promotions.styles.magnumbet';

export const styleImports: Partial<Record<EThemesOG, any>> = {
  sterlingparker,
  betroyale,
  puntcity,
  betprofessor,
  junglebet,
  juicybet,
  puntgenie,
  volcanobet,
  goldenrush,
  wellbet,
  questbet,
  vikingbet,
  betgalaxy,
  fiestabet,
  sugarcastle,
  oldgill,
  buffalobet,
  titanbet,
  slambet,
  gigabet,
  betstride,
  templebet,
  goldenbet888,
  hyperbet,
  bet777,
  chromabet,
  bet575,
  epicodds,
  magnumbet,
};
